import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboardPage } from '@pages/admin';

/**
 * Admin Overview Page
 *
 * Route: /:locale/admin/overview
 */
export const Route = createFileRoute('/$locale/_authenticated/admin/overview')({
  component: AdminOverview,
});

function AdminOverview() {
  return <AdminDashboardPage />;
}
